<template>
  <div>
    <app-heading :text="'Appointments'" :heading="'main'"></app-heading>

    <v-row class="mb-4">
      <v-col cols="12" sm="9" md="9" class="py-0">
        <v-row>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Completed"
              v-model="filterCompleted"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Cancelled"
              v-model="filterCancelled"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Rejected"
              v-model="filterRejected"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="3" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
        <app-search @search="onGridSearch"></app-search>
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cellClicked="onRowClicked"
      rowSelection="single"
    ></ag-grid-vue>

    <view-appointment
      :viewAppointment="viewAppointment"
      :appointmentData="appointmentData"
      @close-appointment="onClose"
    ></view-appointment>
  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import { formatDateTime, formatStatus } from "@/plugins/global-functions";

export default {
  name: "AppointmentManagement",
  components: { AgGridVue },
  data: () => ({
    isEditing: false,
    viewAppointment: false,
    appointmentData: {},
    statusFilter: -1,
    filterCompleted: false,
    filterCancelled: true,
    filterRejected: true,
    pageSize: 50,
    keyword: null,
    items: [],
    columnDefs: [
      {
        headerName: "Order ID",
        field: "optusOrderId",
      },
      {
        headerName: "Appointment ID",
        field: "appointmentId",
      },
      {
        headerName: "Appointment Time",
        field: "startDate",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "Planned Completion Date",
        field: "endDate",
        cellRenderer: function (data) {
          return formatDateTime(data.value, true);
        },
      },
      {
        headerName: "Status",
        field: "status",
        cellRenderer: function (data) {
          return formatStatus(data.value);
        },
      },
      {
        headerName: "Ticket ID",
        field: "jsonData",
        cellRenderer: function (data) {
          let parsedData = JSON.parse(data.value);
          let newItem = parsedData.CustomerReference;
          if (parsedData.CustomerReference.includes("_")) {
            newItem = parsedData.CustomerReference.slice(
              newItem.indexOf("_") + 1,
              parsedData.length
            );
          }
          return `<a href="https://vonex.kayako.com/agent/conversations/${newItem}" class="ticket-link" target="_blank">${parsedData.CustomerReference}</a>`;
        },
      },
    ],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
  }),
  computed: {
    filteredItems: function () {
      let vm = this;
      let items = vm.appointments;

      if (!vm.filterCompleted) items = items.filter((x) => x.status != 4);

      if (!vm.filterCancelled) items = items.filter((x) => x.status != 0);

      if (!vm.filterRejected) items = items.filter((x) => x.status != 1);

      return items;
    },
  },
  beforeMount() {
    let vm = this;

    vm.setAppointmentSearch({
      keyword: null,
      statusFilter: -1,
      pageSize: 50,
    });

    vm.getAppointments()
      .then((data) => {
        vm.items = data;
        vm.gridApi.sizeColumnsToFit();
      })
      .catch(() => {});
  },
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    onRowClicked(args) {
      let vm = this;
      if (args.column.colId === "jsonData") return false;
      vm.viewAppointment = true;
      vm.appointmentData = args.data;
    },
    onClose() {
      let vm = this;
      vm.viewAppointment = false;
    },
    onGridSearch(keyword) {
      let vm = this;

      if (vm.statusFilter === null) vm.statusFilter = -1;

      vm.keyword = keyword;

      vm.setAppointmentSearch({
        keyword: vm.keyword,
        statusFilter: parseInt(vm.statusFilter),
        pageSize: parseInt(vm.pageSize),
      });

      clearTimeout(vm._timerId);

      vm._timerId = setTimeout(() => {
        vm.getAppointments()
          .then(() => {
            vm.gridApi.sizeColumnsToFit();
          })
          .catch(() => {});
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.appointment {
  ::v-deep thead tr {
    background-color: #333c45;
    color: #fff;
  }
  ::v-deep thead tr th span {
    color: #fff;
    font-size: 15px !important;
  }
  ::v-deep thead tr th .v-icon::before {
    color: #fff !important;
  }
  ::v-deep .v-data-table-header-mobile {
    display: none;
  }
  ::v-deep tbody tr {
    cursor: pointer;
  }
  ::v-deep tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05) !important;
  }
  ::v-deep .v-data-table__mobile-table-row {
    display: block;
  }
}

.custom-width {
  width: 115px !important;
}

::v-deep .ticket-link {
  text-decoration: underline;
  color: #2f5578;
  cursor: pointer;
  font-weight: bold;
}
</style>